/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleFactOwnershipTransitionAuditData } from './GoogleFactOwnershipTransitionAuditData';
import {
    GoogleFactOwnershipTransitionAuditDataFromJSON,
    GoogleFactOwnershipTransitionAuditDataFromJSONTyped,
    GoogleFactOwnershipTransitionAuditDataToJSON,
    GoogleFactOwnershipTransitionAuditDataToJSONTyped,
} from './GoogleFactOwnershipTransitionAuditData';
import type { GoogleFactOwnershipData } from './GoogleFactOwnershipData';
import {
    GoogleFactOwnershipDataFromJSON,
    GoogleFactOwnershipDataFromJSONTyped,
    GoogleFactOwnershipDataToJSON,
    GoogleFactOwnershipDataToJSONTyped,
} from './GoogleFactOwnershipData';

/**
 * 
 * @export
 * @interface GoogleFactOwnershipDiagnosticsData
 */
export interface GoogleFactOwnershipDiagnosticsData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleFactOwnershipDiagnosticsData
     */
    hasConflictingPrimaryIntervals?: boolean;
    /**
     * 
     * @type {Array<GoogleFactOwnershipData>}
     * @memberof GoogleFactOwnershipDiagnosticsData
     */
    contracts?: Array<GoogleFactOwnershipData>;
    /**
     * 
     * @type {Array<GoogleFactOwnershipTransitionAuditData>}
     * @memberof GoogleFactOwnershipDiagnosticsData
     */
    transitions?: Array<GoogleFactOwnershipTransitionAuditData>;
}

/**
 * Check if a given object implements the GoogleFactOwnershipDiagnosticsData interface.
 */
export function instanceOfGoogleFactOwnershipDiagnosticsData(value: object): value is GoogleFactOwnershipDiagnosticsData {
    return true;
}

export function GoogleFactOwnershipDiagnosticsDataFromJSON(json: any): GoogleFactOwnershipDiagnosticsData {
    return GoogleFactOwnershipDiagnosticsDataFromJSONTyped(json, false);
}

export function GoogleFactOwnershipDiagnosticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleFactOwnershipDiagnosticsData {
    if (json == null) {
        return json;
    }
    return {
        
        'hasConflictingPrimaryIntervals': json['hasConflictingPrimaryIntervals'] == null ? undefined : json['hasConflictingPrimaryIntervals'],
        'contracts': json['contracts'] == null ? undefined : ((json['contracts'] as Array<any>).map(GoogleFactOwnershipDataFromJSON)),
        'transitions': json['transitions'] == null ? undefined : ((json['transitions'] as Array<any>).map(GoogleFactOwnershipTransitionAuditDataFromJSON)),
    };
}

export function GoogleFactOwnershipDiagnosticsDataToJSON(json: any): GoogleFactOwnershipDiagnosticsData {
    return GoogleFactOwnershipDiagnosticsDataToJSONTyped(json, false);
}

export function GoogleFactOwnershipDiagnosticsDataToJSONTyped(value?: GoogleFactOwnershipDiagnosticsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasConflictingPrimaryIntervals': value['hasConflictingPrimaryIntervals'],
        'contracts': value['contracts'] == null ? undefined : ((value['contracts'] as Array<any>).map(GoogleFactOwnershipDataToJSON)),
        'transitions': value['transitions'] == null ? undefined : ((value['transitions'] as Array<any>).map(GoogleFactOwnershipTransitionAuditDataToJSON)),
    };
}

